import { Component, Inject } from '@angular/core';
import { MB_DIALOG_DATA, MbDialogData, MbDialogRef, MbDialogBody, MbButton, MbDialogFooter } from '@am/moebius';
import { environment } from '@env';
import { CurrencyPipe } from '@shared/pipes/currency.pipe';

@Component({
    selector: 'provider-dialog',
    templateUrl: './provider-dialog.component.html',
    styleUrls: ['./provider-dialog.component.scss'],
    standalone: true,
    imports: [
        MbDialogBody,
        MbDialogFooter,
        MbButton,
        CurrencyPipe,
    ],
})
export class ProviderDialogComponent {
  urlPolcom = environment.boUrl;

  constructor(
    @Inject(MB_DIALOG_DATA) public dialogData: MbDialogData,
    public dialogRef: MbDialogRef<ProviderDialogComponent>,
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
